import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnseignantService {
  private apiUrl="";
    constructor(private http:HttpClient) { }

  getEnseignantInfo() : Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getInfo`);
  }

  getOpenClasseList() : Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getOpenClasseList`);
  }

  getEnseignantClasses() : Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getClasseList`);
  }
  getEtudiantsClasse(id) : Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getListEtudiantsClasse/${id}`);
  }
  addSessionPresence(session:{DateDebut:string,DateFin:string,ClasseId:string,Instituteur:string,Matiere:string,Remarque:string,Activite:string,Groupe:string}):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addSessionPresence`,session);
  }
  updateSessionPresence(session:{DateDebut:string,DateFin:string,IdMatiere:string,StatutId:string,Remarque:string,Activite:string,IdPresence:string,Instituteur:string,ClasseId:string}):Observable<any>{
    return this.http.put(`${this.apiUrl}/api/Enseignant/updateSessionPresence`,session);
  }
  getMatiereList(classe): Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getMatiereList?classe=${classe}`);

  }

  getClasseEtudiants(id,groupe):Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getListEtudiants?id=${id}&groupe=${groupe}`);
  }

  getSessionsPresence(idClasse?):Observable<any>{
    if(idClasse){
      return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionPresence?idClasse=${idClasse}`);
    }
    return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionPresence`);

  }
  getEtatsPresence():Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getEtatsPresence`);
  }
  LoadPresenceEtudiants(id):Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/LoadPresenceEtudiants?id=${id}`);
  }
  ConfirmPresence(PresenceEtudiants:{IdEtudiant:string,IdPresence:string,IdEtatPresence:string,Commentaire:string}):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/ConfirmPresence`,PresenceEtudiants);
  }
  
  getStatutPresence():Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/getStatutsPresenceSession`);
  }

  //Eval

  getSessionsEval(id?,dateDebut?,dateFin?):Observable<any>{
    if(id && dateDebut && dateFin){
      return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionEval?idClasse=${id}&&dateDebut=${dateDebut}&&dateFin=${dateFin}`);
    }
    if (id && dateDebut){
      return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionEval?idClasse=${id}&&dateDebut=${dateDebut}`);
    }
    if (id && dateFin){
      return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionEval?idClasse=${id}&&dateFin=${dateFin}`);
    }
    if(id){
      return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionEval?idClasse=${id}`);
    }
    return this.http.get(`${this.apiUrl}/api/Enseignant/getSessionEval`);
  }
  addSessionEval(session:{Designation:string,ClasseId:string,IdInstituteur:string,DateDebut:string,DateFin:string}):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addEvalSession`,session);
  }
  deleteSessionEval(id):Observable<any>{
    return this.http.delete(`${this.apiUrl}/api/Enseignant/deleteEvalSession?id=${id}`);
  }
  getEtatsSessionEval():Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEtatsSessionEval`);

  }
  updateSessionEval(session:{DateDebut:string,DateFin:string,EvalSessionId:string,Designation:string,IdEtat:string,ClasseId:string,IdInstituteur:string}):Observable<any>{
    return this.http.put(`${this.apiUrl}/api/Enseignant/updateEvalSession`,session);
  }
  getEvalEtudiants(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEvalEtudiants?id=${id}`);

  }
  getDetailEvalEtudiants(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getDetailEvalEtudiant?id=${id}`);

  }
  getCritereEval(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getCritereEval?id=${id}`);
  }
  getMention():Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getMention`);
  }
  getOneDetailEvalEtudiant(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getOneDetailEvalEtudiant?id=${id}`);
  }
  addDetailEval(evaluation:{IdEvalEtudiantSession:string,Critere:string,Mention:string,Commentaire:string}):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addEvalDetail`,evaluation);
  }
  updateDetailEval(evaluation:{IdEvalEtudiant:string,IdEvalEtudiantSession:string,Critere:string,Mention:string,Commentaire:string}):Observable<any>{
    return this.http.put(`${this.apiUrl}/api/Enseignant/updateEvalDetail`,evaluation);
  }
  deleteDetailEval(id):Observable<any>{
    return this.http.delete(`${this.apiUrl}/api/Enseignant/deleteDetailEval?id=${id}`);
  }

  // Sanction
  GetSanctionsClasse(id?):Observable<any>{
    if(id){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetSanctionsClasse?id=${id}`);
    }
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetSanctionsClasse`);
  }
  GetSanction(id):Observable<any>{   
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetSanction?id=${id}`);
  }
  GetSanctionsType(id) : Observable<any>{
    return this.http.get(`${this.apiUrl}/api/Enseignant/GetSanctionsType/${id}`);
  }
  addSanction(sanction:{Type:string,Commentaire:string,EtudiantId:string,ClasseId:string,ProfId:string,SocieteId:string,EtatId:string}):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addSanctions`,sanction);
  }
  updateSanction(sanction:{Id:string,Type:string,Commentaire:string,EtudiantId:string,ClasseId:string,ProfId:string,SocieteId:string,EtatId:string}):Observable<any>{
    return this.http.put(`${this.apiUrl}/api/Enseignant/UpdateSanctions`,sanction);
  }
  DeleteSanctions(id):Observable<any>{   
    return this.http.delete<any[]>(`${this.apiUrl}/api/Enseignant/DeleteSanctions?id=${id}`);
  }
  getSocInfo(){
    return this.http.get<any>(`${this.apiUrl}/api/Enseignant/getSocInfo`);
  }
  //TRAVAUX
  GetTravauxClasseProf(idClasse?,dateDebut?,dateFin?):Observable<any>{
    if(idClasse && dateDebut && dateFin){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?idClasse=${idClasse}&&dateDebut=${dateDebut}&&dateFin=${dateFin}`);
    }
    if(dateDebut && dateFin){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?dateDebut=${dateDebut}&&dateFin=${dateFin}`);
    }
    if (idClasse && dateDebut){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?idClasse=${idClasse}&&dateDebut=${dateDebut}`);
    }
    if (idClasse && dateFin){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?idClasse=${idClasse}&&dateFin=${dateFin}`);
    }
    if(idClasse){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?idClasse=${idClasse}`);
    }
    if(dateDebut){
      return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf?dateDebut=${dateDebut}`);
    }
    return this.http.get(`${this.apiUrl}/api/Enseignant/GetTraveauxMaisonProf`);

  }
  GetTravail(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetTravailMaison?id=${id}`);
  }

  AddTravaux(travail):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addTravailMaison`,travail);
  }
  addTravailMaisonEtudiant(coursInfo):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/addTravailMaisonEtudiant`,coursInfo);
  }
  UpdateTravaux(travail):Observable<any>{
    return this.http.post(`${this.apiUrl}/api/Enseignant/UpdateTravailMaison`,travail);
  }
  DeleteTrvaux(id):Observable<any>{
    return this.http.delete<any[]>(`${this.apiUrl}/api/Enseignant/DeleteTravailMaison?id=${id}`)
  }
  getEmploiEnseignantClasse(classe, enseignant):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Classe=${classe}&Prof=${enseignant}&Statut=2`)
  }
  getEmploiEnseignant(enseignant):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Prof=${enseignant}&Statut=2`)
  }
  getClasseGroupe(classe):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getClasseGroupe?idClasse=${classe}`)
  }
  getEmploiClasse(classe):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Classe=${classe}&Statut=2`)
  }
  getCoursInfo(eventID):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getCoursInfo/`+eventID);
  }
  getEmploiPeriodes(classe){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getPeriodesClasse?id=${classe}`);

  }
  getProfEmploiPeriodes(){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getPeriodesProf`);
  }
  getClassePeriode(classe,periode){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&Periode=${periode}&Statut=2`);
  }
  getProfClassePeriode(classe,prof,periode){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&prof=${prof}&Periode=${periode}&Statut=2`);
  }
  getEtudiants(id){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEtudiants?id=${id}`);

  }
  getEmploiClasseEtudiant(classe,etudiant):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Classe=${classe}&Etudiant=${etudiant}&Statut=2`)
  }
  getPeriodeEmploiClasseEtudiant(classe,etudiant,periode):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&Etudiant=${etudiant}&Periode=${periode}&Statut=2`)
  }
  getFileAttachement(id):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetFileAttachement?id=${id}`);
  }
  downloadFileAttachement(IdFichier,type):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/DownloadFile?id=${IdFichier}&type=${type}`);
  }
  deleteFileAttachement(IdFichier,type):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/DeleteFile?id=${IdFichier}&type=${type}`);
  }


  public getNotificationsCount(id){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getNotificationsCount?id=${id}`);
  }

  public readAllNotif(id){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/readAllNotif?id=${id}`);
  }
  public getNotifications(id){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getNotification?id=${id}`);
  }
  public getEmploiPeriode(classe,periode,groupe):Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&Groupe=${groupe}&Periode=${periode}&Statut=2`)
  }
  public getEmploi(classe,groupe,prof?):Observable<any>{
    if(prof){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Classe=${classe}&Groupe=${groupe}&Prof=${prof}&Statut=2`)
    }else{
      return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/getEmploi?Classe=${classe}&Groupe=${groupe}&Statut=2`)
    }
  }
  public getEmploiPeriodeGroupe(classe,groupe?,periode?,prof?):Observable<any>{
    if(prof){
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&Groupe=${groupe}&Prof=${prof}&Periode=${periode}&Statut=2`)
    }else{
      return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetWithPeriode?Classe=${classe}&Periode=${periode}&Groupe=${groupe}&Statut=2`)
    }
  }

  public getTypeDocument():Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetTypeDocument`)
  }
  public GetPlanificationsExamenDetails():Observable<any>{
    return this.http.get<any[]>(`${this.apiUrl}/api/Enseignant/GetPlanificationsExamenDetails`)
  }
}
